import clsx from 'clsx'
import { IconButton } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import effects from '../../../effects/effects'
import { currentTotalToPercentage } from '../../../../libs/math'

const useStyles = makeStyles((theme) => ({
  photoContainer: {
    position: 'relative',
    display: 'inline-block',
    height: 113,
    margin: 10,
    marginBottom: 0,
  },
  photoContainerLoading: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    background: 'white',
    opacity: 0.8,
  },
  photoImg: {
    width: 181,
    height: 113,
    objectFit: 'cover',
  },
  deleteContainer: {
    position: 'absolute',
    right: 9,
    bottom: 7,
    background: 'white',
    width: 23,
    height: 23,
    fontSize: 2,
    '&:hover': {
      backgroundColor: 'white',
    },
  },
  deleteIc: {
    fontSize: '1.8rem',
    color: '#0073b1',
  },
  progressContainer: {
    height: 10,
    background: 'rgb(6 78 117 / 19%)',
    position: 'absolute',
    bottom: 12,
    left: 10,
    right: 10,
    borderRadius: 6,
  },
  progressBar: {
    background: '#064e75',
    height: '100%',
    borderRadius: 6,
  },
  '@media (max-width: 780px)': {
    photoImg: {
      width: 271.5,
      height: 169.5,
    },
    photoContainer: {
      height: 169.5,
    },
  },
  '@media (max-width: 690px)': {
    photoImg: {
      width: 155,
      height: 100,
    },
    photoContainer: {
      height: 100,
    },
  },
}))

export const Photo = ({ img, onDelete }) => {
  const classes = useStyles()
  const [percentage, setPercentage] = useState(false)
  const [updatedId, setUpdatedId] = useState(false)
  const onProgressBar = (e) => {
    const { loaded, total } = e
    setPercentage(currentTotalToPercentage(loaded, total))
  }

  const uploadPhoto = (imageData, index) => {
    return effects.apis.uploadPhotos(imageData, onProgressBar, index)
  }

  useEffect(() => {
    if (img.uploadStatus && img.uploadStatus === 1) {
      uploadPhoto(img.path, img.id).then(({ id }) => setUpdatedId(id))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={clsx(classes.photoContainer)} key={img.id}>
      <img className={classes.photoImg} src={img.path} alt="" />
      {!(typeof percentage === 'number' && percentage < 100) && (
        <IconButton
          className={classes.deleteContainer}
          onClick={(ev) => {
            ev.stopPropagation()
            const deletableId = updatedId === false ? img.id : updatedId
            onDelete([deletableId], [img.id])
          }}
        >
          <DeleteIcon className={classes.deleteIc} />
        </IconButton>
      )}
      {typeof percentage === 'number' && percentage < 100 && (
        <div className={classes.photoContainerLoading} />
      )}
      {typeof percentage === 'number' && percentage < 100 && (
        <div>
          <div className={classes.progressContainer}>
            <div
              className={classes.progressBar}
              style={{ width: percentage }}
            />
          </div>
        </div>
      )}
    </div>
  )
}
